export const LABEL_STORE = 'LABEL_STORE';
export const LABEL_UPDATE = 'LABEL_UPDATE';
export const LABEL_DESTROY = 'LABEL_DESTROY';
